module.exports = __webpack_public_path__ + "img/child.e11e93e7.svg";